import React, { Component, Fragment } from 'react';
import OKLogin from 'ok-login';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Modal } from 'react-bootstrap';
import { initOptions } from 'ok-login';
import apiURLBuilder, { getURL } from 'core/apiURLBuilder';
import preLoaderActions from 'actions/preLoaderActions';
const PropTypes = require('prop-types');
import { getLanguage } from 'core/i18n';
import { getLocationOrigin } from 'utilities/initialization';
import { getReferenceCodeByCountry } from 'utilities/multiLanguageHelper';
const { LOCAL_ENVIRONMENT, PROD_ENVIRONMENT } = require('constants/index');

class LoginModal extends Component {
    constructor(props) {
        super(props);
    }

    defaultLoginSuccess = response => {
        const { preLoaderActions } = this.props;
        preLoaderActions.showPreLoader();
        location.href = getLocationOrigin() + `/login/${response.token}`;
    };

    render = () => {
        const { onLoginSuccess, onLoginError, onLinkClick, url, payload, version } = this.props;
        const config = {
            lang: getLanguage(),
            country: __ORIGIN_COUNTRY__, // Initially hardcoded
            version: version,
            isModal: true,
            authentication: {
                url: url,
                headers: { version: version, originCountry: getReferenceCodeByCountry().toUpperCase() },
                payload: payload,
                captchaFlagUrl: apiURLBuilder.getURL('captchaFlag'),
                captchaKey: __HCAPTCHA_LOGIN_SITEKEY__,
            },
            onLoginSuccess: response =>
                onLoginSuccess
                    ? onLoginSuccess(response, () => {
                          this.defaultLoginSuccess(response);
                      })
                    : this.defaultLoginSuccess(response),
            onLoginError: params => onLoginError(params),
            onLinkClick: () => onLinkClick,
            ...(__ENV__ !== LOCAL_ENVIRONMENT
                ? {
                      cookiesDomain:
                          __ENV__ === PROD_ENVIRONMENT
                              ? `.openbank.${__ORIGIN_COUNTRY__}`
                              : `.${__ENV__}.openbank.${__ORIGIN_COUNTRY__}`,
                  }
                : {}),
            onClose: () => {
                this.props.onClose();
            },
        };
        const options = initOptions(config);
        return (
            <Fragment>
                <Modal
                    animation={false}
                    backdrop="static"
                    dialogClassName="joint-holder-decision-container__login-dialog"
                    keyboard={false}
                    show={this.props.show}
                >
                    <Modal.Body>
                        <div className="login login--in" id="customLoginContainer">
                            <OKLogin options={options} />
                        </div>
                    </Modal.Body>
                </Modal>
            </Fragment>
        );
    };
}

LoginModal.propTypes = {
    onLoginSuccess: PropTypes.func,
    onLoginError: PropTypes.func,
    onLinkClick: PropTypes.func,
    payload: PropTypes.object,
    url: PropTypes.string,
    version: PropTypes.number,
};

LoginModal.defaultProps = {
    onLoginError: () => {},
    onLinkClick: () => {},
    payload: { force: true },
    url: getURL('login'),
    version: 5,
};

module.exports.constructor = LoginModal;

module.exports.LoginModal = connect(
    () => ({}),
    dispatch => ({
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
    })
)(LoginModal);
